import * as React from "react";
import { Children, ReactNode } from "react"

interface EachProps<T> {
  render: (item: any, index: number) => ReactNode;
  of: T[];
}

function Each<T>({ render, of }: EachProps<T>): ReactNode {
  if (!of?.length) {
    return <></>;
  }
  return Children.toArray(of.map((item, index) => render(item, index)));
}

export default Each;
